export const LOADING_BLOGS = "LOADING_BLOGS";
export const SUCCESS_GET_BLOGS = "SUCCESS_GET_BLOGS";
export const SUCCESS_GET_MOST_SEEN_BLOGS = "SUCCESS_GET_MOST_SEEN_BLOGS";
export const SUCCESS_GET_ALL_BLOGS = "SUCCESS_GET_ALL_BLOGS";
export const SET_ERROR_BLOGS = "SET_ERROR_BLOGS";
export const RESET = "RESET";